import React, { useMemo, useState } from "react";

import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";

import { deleteResalefromIndex } from "@pages/dashboard/SubmitAllResales";
import { resaleFormData } from "@states/resale_submission";

import { ROUTES } from "../../../routes";
import { ValidatedResaleInput } from "../csv/ParseFiles";

import { CartButton } from "./CartButton";
import { CartDrawer, CartDrawerContentProps } from "./CartDrawer";

import styles from "./ResaleCart.module.scss";

export const ResaleCart = () => {
  /**
   * @param isDrawerOpen Whether the the summary cart is open or not
   */
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const [multiFormData, setMultiFormData] = useRecoilState(resaleFormData);

  const resaleIsInvalid = (resale: ValidatedResaleInput) => {
    return resale.validation && resale.validation.success === false;
  };

  const multiFormDataCartContent: CartDrawerContentProps[] = useMemo(
    () =>
      multiFormData.map((item) => {
        return {
          title: item.artwork?.artwork_name || "",
          owner: item.artist?.provisional_artist_name || "",
          status: resaleIsInvalid(item) ? "Error" : "Completed",
          showEditAndDeleteButton: false,
        };
      }),
    [multiFormData],
  );

  const handleCartButtonClick = () => {
    setIsDrawerOpen(true);
  };

  const handleCartClose = () => {
    setIsDrawerOpen(false);
  };

  /**
   * @function handleResaleEdit
   * should be called when edit button is clicked in the summary cart
   * @function handleResaleDelete
   * should be called when delete button is clicked in the summary cart
   * @function handleGoToSummary
   * should be called when the summary button is clicked in the summary cart
   * @param index
   * index of the item to be edited or deleted in the cart
   */
  const handleResaleEdit = (index: number) => {
    navigate(ROUTES.ResaleSubmission.buildPath({}, { index_id: index - 1 }));
  };

  const handleResaleDelete = (index: number) => {
    setMultiFormData(deleteResalefromIndex(index - 1, multiFormData));
  };

  const handleGoToSummary = () => {
    navigate(ROUTES.SubmitAllResales.path);
  };

  return (
    <>
      <div className={classNames(styles["cart-button-top-right"], "z-3")}>
        <CartButton badgeNumber={multiFormData.length} onClick={handleCartButtonClick} />
      </div>
      <CartDrawer
        contents={multiFormDataCartContent}
        isDrawerOpen={isDrawerOpen}
        onHide={handleCartClose}
        onEditClick={handleResaleEdit}
        onDeleteClick={handleResaleDelete}
        onGoToSummary={handleGoToSummary}
      />
    </>
  );
};
